import * as React from 'react'
import { format, differenceInDays } from 'date-fns';
import { Popover } from '../../components/ui/Popover';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Spinner } from 'reactstrap';
import { detectIE } from '../../util/dom';
import { userData } from '../../util/userData';
import { HttpRequest } from '../../util/http';
import { Page, Text, View, Document, StyleSheet, BlobProvider } from '@react-pdf/renderer';
import { IActionAlertForm } from "../MyAlertsContainer/interfaces";
import { prepareForExport, printExport } from "../MyAlertsContainer/lib/export";
import { notify } from "./lib/notification/notification";
import { addUser, getAvidLabel, getCoachingFormInfo, getUsers, verifyActiveUser, verifyAvidAccess } from "./lib/http";
import { FormView } from "./lib/FormView";
import { FormEdit } from "./lib/FormEdit";

interface FormState extends formState {
  targetNote?: number,
  openDeleteModalConfirmationPopUp: boolean
  isConfirmDeleteModalOpen: any;
  alertTypes: IAlertType[]
  assignedBy?: string
  confirmationModalText?: string
  confirmationProcess?: boolean
  customerInfo?: ICustomerInformation
  customerMemberName: string
  defaultHierarchyValue?: string
  exportedAlerts: IActionAlertForm[],
  hierarchyValues?: string[]
  inputHierarchyValues?: string[]
  inputSelectedAvid?: string
  isConfirmTeamModalOpen: boolean
  isConfirmationModalOpen: boolean
  isInactiveUser: boolean;
  isLoading: boolean
  isRootCauseInputValid: boolean
  loadedChunk: Set<string>
  loadingChunk: string[]
  loadingProjectName: boolean
  newUserEmail?: string
  noTeamCheckbox?: boolean
  projectName: string
  selectedAvid?: string
  selectedAvidLabel?: string
  teamConfirmationText: string
  isLoadingExternalRef?: boolean
  isCreatingAlert?: boolean
  creationProgress?: 'creating' | 'creating_complete' | 'syncing' | 'syncing_complete' | 'syncing_failed'
  isUpdatingAlert?: boolean
  updateProgress?: 'updating' | 'updating_complete' | 'syncing' | 'syncing_complete' | 'syncing_failed'
}

interface IAlertType {
  id: number
  name: string
  description: string
}

interface IActionTakenObj {
  actionTaken: string
  shouldNotify: boolean
}

export class ActionAlertFormContainer extends React.Component<formProps, FormState> {

  state: FormState = {
    alert: {
      id: undefined,
      createdOn: format(new Date(), 'P'),
      source: 'string',
      description: '',
      assignedTo: '',
      assignedToID: 0,
      statusID: 0,
      status: '0',
      statusColor: '',
      reason: 0,
      reasonLabel: '',
      externalReferenceID: 0,
      rootCause: '',
      rootCauseID: 0,
      endState: '',
      endStateID: 0,
      severity: '',
      severityID: 0,
      severityColor: ''
    },
    PDFready: false,
    adminList: [],
    alertTypes: [],
    customerMemberName: '',
    enabledInputs: [],
    endStates: [],
    exportedAlerts: [],
    externalDataReference: undefined,
    hierarchyValues: [],
    history: [],
    inputActionTaken: 'string',
    inputAssignee: 0,
    inputDescription: 'string',
    inputDueDate: new Date(),
    inputEndState: 0,
    inputReason: -1,
    inputRootCause: 0,
    inputSeverity: 0,
    inputStatus: 0,
    isChildAlert: false,
    isConfirmTeamModalOpen: false,
    isConfirmDeleteModalOpen: false,
    openDeleteModalConfirmationPopUp: false,
    isConfirmationModalOpen: false,
    isEditMode: false,
    isInactiveUser: false,
    isLoading: true,
    isNewAlert: false,
    isNotesModalOpen: false,
    isRootCauseInputValid: false,
    isValid: true,
    loadedChunk: new Set(),
    loadingChunk: ['reasons', 'users', 'status'],
    loadingProjectName: false,
    newUser: false,
    newUserWarning: false,
    notes: [],
    notesModalOpen: false,
    pristine: true,
    projectName: '',
    reasons: [],
    requiredInputs: ['inputReason', 'inputAssignee', 'inputDescription', 'inputStatus'],
    rootCauses: [],
    severityList: [],
    statusTypes: [],
    users: [],
    teamConfirmationText: ''
  }
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  getNotesListener = () => this.getNotes();

  componentWillMount() {
    let avid = (this.props.relatedAvid ? this.props.relatedAvid : '');
    if (avid.length == 0) {
      userData.filtersListen((filters => {
        this.setState({ defaultHierarchyValue: filters.hier, hierarchyValues: [filters.hier] });
      }))
    } else this.setState({ defaultHierarchyValue: avid, hierarchyValues: [avid] });
  }

  componentDidMount() {
    window.addEventListener('updateNotesEvent', this.getNotesListener);
    this.loadData();
    this.getReasons();
    this.getSeverityList();
    this.getAlertTypes();
    this.setUsers();
    this.getStatusTypes();
    this.getProjectName();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props != prevProps) {
      let ignoreCount = 0;
      let totalCount = 0;
      const ignoreUpdatesList = ['customer', 'toggleModal'];
      for (const key in this.props) {
        if (this.props[key] !== prevProps[key]) {
          totalCount++;
          if (ignoreUpdatesList.includes(key)) ignoreCount++;
        }
      }
      if (totalCount > ignoreCount) {
        this.loadData();
      }
    }

    if (this.props.alertID != prevProps.alertID) {
      let { alert } = this.state;
      alert.id = this.props.alertID;
      this.setState({ alert });
    }
    if (this.state.alert != prevState.alert) {
      this.getCustomerInfo();
    }

    if (prevState != this.state) {
      if (this.state.projectName.length == 0)
        this.getProjectName();
    }
  }

  loadData(keepEditMode = false) {
    if (this.props.alertID || this.state.alert.id) {
      let { alert, requiredInputs } = this.state;
      alert.id = this.props.alertID;
      this.setState({ alert: alert, isEditMode: keepEditMode, requiredInputs: requiredInputs }, () => {
        this.loadAlert(alert.id);
      });
    } else {
      this.loadDefaults();
    }
  }

  loadDefaults() {
    let { alert, requiredInputs } = this.state;
    // requiredInputs = requiredInputs.filter((input) => input != 'inputActionTaken');
    alert.id = this.props.alertID;
    alert.createdOn = format(new Date(), 'P');
    alert.source = 'string';
    alert.description = '';
    alert.assignedTo = '';
    alert.assignedToID = 0;
    alert.statusID = 0;
    alert.status = '0';
    alert.severity = '';
    alert.severityID = 0;
    alert.statusColor = '';
    alert.reason = 0;
    alert.reasonLabel = '';
    alert.externalReferenceID = (this.props.externalReferenceID ? this.props.externalReferenceID : 0);
    alert.rootCause = '';
    alert.rootCauseID = 0;
    alert.endState = '';
    alert.endStateID = 0;
    alert.dueDate = undefined;
    alert.avidObj = { avid: undefined, label: 'No Team' }
    this.setState({
      alert: alert,
      isEditMode: true,
      isNewAlert: true,
      requiredInputs: requiredInputs
    });
    this.cleanInputs();
  }

  loadAlert(id: number) {
    if (id) {
      this.setState({
        isNewAlert: false,
        isChildAlert: false
      });
      const data = { id: id };
      const method = 'POST';
      HttpRequest.fetch('scripts/alert_form/get_alert', { data, method })
        .then((res: Alert) => {
          if (res.dueDate == '0000-00-00 00:00:00') {
            res.dueDate = undefined;
          }
          let alert = this.state.alert;
          alert.id = id;
          alert.createdOn = format(new Date(res.createdOn), 'P');
          alert.dueDate = res.dueDate ? format(new Date(res.dueDate), 'P') : undefined;
          alert.source = res.source;
          alert.description = (res.description ? res.description : '');
          alert.assignedTo = (res.assignedTo ? res.assignedTo : '');
          alert.assignedToID = (res.assignedToID ? res.assignedToID : -1);
          alert.statusID = (res.statusID >= 0 ? res.statusID : -1);
          alert.status = (res.status ? res.status : '');
          alert.severityID = (res.severityID ? res.severityID : -1);
          alert.severity = (res.severity ? res.severity : '');
          alert.severityColor = (res.severityColor ? res.severityColor : '');
          alert.statusColor = (res.statusColor ? res.statusColor : '');
          alert.reason = (res.reason ? res.reason : -1);
          alert.reasonLabel = (res.reasonLabel ? res.reasonLabel : '');
          alert.externalReferenceID = (res.externalReferenceID ? res.externalReferenceID : undefined);
          alert.rootCause = (res.rootCause ? res.rootCause : '');
          alert.rootCauseID = (res.rootCauseID ? res.rootCauseID : -1);
          alert.endState = (res.endState ? res.endState : '');
          alert.endStateID = (res.endStateID ? res.endStateID : -1);
          alert.assignedBy = (res.assignedBy ? res.assignedBy : 'Non specified');
          alert.avidObj = {
            avid: (res.avidObj.avid ? res.avidObj.avid : undefined),
            label: (res.avidObj.label ? res.avidObj.label : 'No Team')
          };
          this.setState({ alert: alert }, this.getCustomerInfo);
          this.populateInputs();
          this.getNotes();
          this.getHistory();
          if (alert.avidObj.avid) this.setState({ defaultHierarchyValue: alert.avidObj.avid, hierarchyValues: [alert.avidObj.avid], noTeamCheckbox: false });

        });
    } else {
      this.loadDefaults();
      this.setState({ isEditMode: true });
    }
  }

  getProjectName() {
    if (!this.state.loadingProjectName) {
      let currentProject = userData.getCurrentProject();
      if (currentProject && currentProject.length > 0) {
        const data = { current_project: currentProject };
        const method = 'POST';
        this.setState({ loadingProjectName: true }, () => {
          HttpRequest.fetch('scripts/my_alerts/getProjectName', { data, method }).then((res: any) => {
            if (res) {
              this.setState({ projectName: res.name, customerMemberName: res.memberName.toLowerCase() });
              this.getRootCauses();
              this.getEndStates();
              this.getActionAlertPermissions();
              this.getCustomerInfo();
              this.getAdminList();
            }
            this.setState({ loadingProjectName: false });
          });
        })
      }
    }
  }

  getStatusIcon(status: string) {
    if (status === 'New') {//Will be updated from Unresolved to New
      return 'bell'
    }
    if (status === 'Added') { //deprecated
      return null
      //return bell"
    }
    if (status === 'Pending') {
      return 'bell'
    }
    if (status === 'Resolved') {
      return 'thumbs-up'
    }
    if (status === 'No Action Needed') {
      return 'minus-circle'
    }
    return 'bell'
  }

  cleanInputs() {
    let inputStatus = this.state.statusTypes.find((status) => status.status == 'New');
    this.setState({
      inputStatus: (inputStatus ? inputStatus.id : -1),
      inputAssignee: -1,
      inputReason: -1,
      inputDueDate: new Date(),
      inputSeverity: 0,
      inputRootCause: -1,
      inputEndState: -1,
      inputDescription: '',
      inputActionTaken: '',
      inputAddNote: '',
      isValid: true,
    });
    let avid = (this.props.relatedAvid ? this.props.relatedAvid : '');
    if (avid.length == 0) {
      userData.filtersListen((filters => {
        this.setState({ defaultHierarchyValue: filters.hier, hierarchyValues: [filters.hier], noTeamCheckbox: true });
      }));
    } else this.setState({ defaultHierarchyValue: avid, hierarchyValues: [avid] });
  }

  populateInputs() {
    this.setState({
      inputDueDate: (this.state.alert.dueDate ? new Date(this.state.alert.dueDate) : new Date()),
      inputStatus: (this.state.alert.statusID >= 0 ? this.state.alert.statusID : -1),
      inputAssignee: (this.state.alert.assignedToID >= 0 ? this.state.alert.assignedToID : -1),
      inputReason: (this.state.alert.reason >= 0 ? this.state.alert.reason : -1),
      inputSeverity: (this.state.alert.severityID ? this.state.alert.severityID : -1),
      inputRootCause: (this.state.alert.rootCauseID >= 0 ? this.state.alert.rootCauseID : -1),
      inputEndState: (this.state.alert.endStateID >= 0 ? this.state.alert.endStateID : -1),
      inputDescription: this.state.alert.description,
      inputActionTaken: '',
      isValid: true
    });
  }

  getReasons() {
    let { loadedChunk } = this.state;
    const method = 'POST';
    HttpRequest.fetch('scripts/my_alerts/get_reason_list', { method })
      .then((res: any) => {
        let reasons = [];
        reasons.push({ id: -1, reason: "Select a reason" });
        res.reasons.forEach((reason) => {
          reasons.push(reason);
        });
        loadedChunk.add('reasons');
        this.setState({ reasons: reasons, loadedChunk: loadedChunk }, this.setLoadingState);
      })
  }

  getRootCauses() {
    let { loadedChunk } = this.state;
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/rootcause/get_all', { data, method })
      .then((res: any) => {
        let rootCauses = [];
        rootCauses.push({ id: -1, rootCause: "Select a root cause" });
        res.forEach((rootCause) => {
          rootCauses.push({ id: rootCause.id, rootCause: rootCause.label });
        });
        loadedChunk.add('inputRootCause');
        this.setState({ rootCauses: rootCauses, loadedChunk: loadedChunk }, this.setLoadingState);
      })
  }

  getEndStates() {
    let { loadedChunk } = this.state;
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/endstate/get_all', { data, method })
      .then((res: any) => {
        let endStates = [];
        endStates.push({ id: -1, endState: "Select a end state" });
        res.forEach((endState) => {
          endStates.push({ id: endState.id, endState: endState.label });
        });
        loadedChunk.add('inputEndState');
        this.setState({ endStates: endStates, loadedChunk: loadedChunk }, this.setLoadingState);
      })
  }


  promiseSetUsers(isSelectedUser?: number) {
    return new Promise(resolve => {
      let { loadedChunk } = this.state;
      getUsers().then((users) => {
        loadedChunk.add('users');
        let { inputAssignee } = this.state;
        inputAssignee = (isSelectedUser ? isSelectedUser : inputAssignee);
        this.setState({ users: users, loadedChunk: loadedChunk, inputAssignee: inputAssignee }, () => {
          this.setLoadingState();
          resolve(true)
        });
      });
    });
  }
  setUsers(cb?) {
    let { loadedChunk } = this.state;
    getUsers().then((users) => {
      loadedChunk.add('users');
      this.setState({ users: users, loadedChunk: loadedChunk }, () => {
        this.setLoadingState();
        cb
      });
    });
  }

  refreshUsers() {
    getUsers().then((users) => {
      this.setState({ users: users, isInactiveUser: false, inputAssignee: -1 });
    });
  }

  getUsers() {
    let { loadedChunk } = this.state;
    const project = userData.getCurrentProject();
    userData.getUserId().then((userId) => {
      const data = { current_project: project, user_id: userId };
      const method = 'POST';
      HttpRequest.fetch('scripts/my_alerts/get_user_list', { data, method })
        .then((res: any) => {
          let users = [];
          users.push({ id: -1, email: "Select a user", username: "Select a user" });
          res.users.forEach((user) => {
            users.push(user);
          });
          loadedChunk.add('users');
          this.setState({ users: users, loadedChunk: loadedChunk }, this.setLoadingState);
        })
    })
  }

  getStatusTypes() {
    let { loadedChunk } = this.state;
    const method = 'POST';
    HttpRequest.fetch('scripts/alert_form/get_status_types', { method })
      .then((res: any) => {
        let statusTypes = [];
        statusTypes.push({ id: -1, status: "Select a status", color: "Select a status" });
        res.statusTypes.forEach((status) => {
          statusTypes.push(status);
        });
        loadedChunk.add('status');
        this.setState({ statusTypes: statusTypes }, this.setLoadingState);
      })
  }

  getAlertTypes() {
    const method = 'POST';
    HttpRequest.fetch('scripts/alert_form/getAlertTypes', { method })
      .then((res: IAlertType[]) => {
        let alertTypes = [];
        res.forEach((alertType) => {
          alertTypes.push(alertType);
        });
        this.setState({ alertTypes: alertTypes });
      })
  }

  getSeverityList() {
    const method = 'POST';
    HttpRequest.fetch('scripts/alert_form/get_severity_list', { method })
      .then((res: any) => {
        let severityList = [];
        res.severityList.forEach((severity) => {
          severityList.push(severity);
        });
        this.setState({ severityList: severityList });
      })
  }

  getActionAlertPermissions() {
    let { requiredInputs, enabledInputs, loadingChunk } = this.state;
    const data = { resource: userData.getCurrentProject(), permission_type: 'ACTIONALERTS' };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/permission/get', { data, method })
      .then((res: Permission[]) => {
        res.forEach((permission) => {
          if (permission.permission_name == 'Enable Root Cause') enabledInputs.push('inputRootCause');
          if (permission.permission_name == 'Enable End State') enabledInputs.push('inputEndState');
          if (permission.permission_name == 'Require Root Cause') requiredInputs.push('inputRootCause');
          if (permission.permission_name == 'Require End State') requiredInputs.push('inputEndState');
        });
        // If an input is required, it must be enabled.
        if (!enabledInputs.includes('inputRootCause') && requiredInputs.includes('inputRootCause')) {
          requiredInputs = requiredInputs.map((input) => {
            if (input != 'inputRootCause') return input;
          });
        }

        if (!enabledInputs.includes('inputEndState') && requiredInputs.includes('inputEndState')) {
          requiredInputs = requiredInputs.map((input) => {
            if (input != 'inputEndState') return input;
          });
        }
        let updatedLoadingChunk = loadingChunk.concat(enabledInputs);
        this.setState({ requiredInputs: requiredInputs, enabledInputs: enabledInputs, loadingChunk: updatedLoadingChunk });
      })
      .catch((res: Error) => {
        console.log(res);
      })
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let partialState = {};
    partialState[name] = value;

    this.setState(partialState)
  }

  resetFormInputs() {

  }

  setLoadingState() {
    const { loadingChunk, loadedChunk } = this.state;
    for (let i = 0; i < loadingChunk.length; i++) {
      if (!loadedChunk.has(loadingChunk[i])) return false;
    }
    this.setState({ isLoading: false });
  }
  updateUserInput(userID: number, newUser: boolean, newUserEmail?: string) {
    if (newUser) {
      let users = this.state.users;
      users.push({
        id: userID,
        email: newUserEmail,
        username: newUserEmail
      })
      this.setState({ inputAssignee: userID, newUser: newUser, newUserWarning: newUser, newUserEmail: newUserEmail, users: users });
    } else {
      this.setState({ inputAssignee: userID });
    }
  }

  setEditMode(value) {
    if (this.state.isNewAlert) {
      if (this.state.isChildAlert) {
        if (value) {
          this.cleanInputs();
          this.setState({ isEditMode: true });
        } else {
          this.populateInputs();
          this.setState({
            isEditMode: false,
            isChildAlert: false,
            isNewAlert: false,
          });
        }
      } else {
        this.cleanInputs();
        this.setState({ isEditMode: false });
        const $alertFormAside = $('#AlertFormAside');
        $alertFormAside.modal('close');
      }
    } else {
      this.populateInputs();
      this.setState({ isEditMode: value });
    }
  }

  /**
   * Set action taken text based on user input and fields updated
   * returns string
   */
  getActionTaken() {
    let actionTakenObj: IActionTakenObj = {
      actionTaken: this.state.inputActionTaken,
      shouldNotify: false
    }

    let updatedValueForinputAssignee = (this.state.inputAssignee != this.state.alert.assignedToID ? this.state.inputAssignee : false);
    if (updatedValueForinputAssignee) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Assignee: ' + this.state.users[this.state.users.findIndex((item) => item.id == updatedValueForinputAssignee)].username;
      actionTakenObj.shouldNotify = true
    }
    let updatedValueForinputReason = (this.state.inputReason != this.state.alert.reason ? this.state.inputReason : false);
    if (updatedValueForinputReason) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Reason: ' + this.state.reasons[this.state.reasons.findIndex((item) => item.id == updatedValueForinputReason)].reason;
    }
    let updatedValueForinputDescription = (this.state.inputDescription != this.state.alert.description ? this.state.inputDescription : '');
    if (updatedValueForinputDescription.length) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Description: ' + updatedValueForinputDescription;
    }
    let updatedValueForinputStatus = (this.state.inputStatus != this.state.alert.statusID ? this.state.inputStatus : false);
    if (updatedValueForinputStatus) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Status: ' + this.state.statusTypes[this.state.statusTypes.findIndex((item) => item.id == updatedValueForinputStatus)].status;
    }
    let updatedValueForinputRootCause = (this.state.inputRootCause != this.state.alert.rootCauseID ? this.state.inputRootCause : false);
    if (updatedValueForinputRootCause) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Root Cause: ' + this.state.rootCauses[this.state.rootCauses.findIndex((el) => el.id == updatedValueForinputRootCause)].rootCause
    }
    let updatedValueForinputEndState = (this.state.inputEndState != this.state.alert.endStateID ? this.state.inputEndState : false);
    if (updatedValueForinputEndState) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: End State: ' + this.state.endStates[this.state.endStates.findIndex((el) => el.id == updatedValueForinputEndState)].endState
    }

    let updatedValueForinputSeverity = (this.state.inputSeverity != this.state.alert.severityID ? this.state.inputSeverity : false);
    if (updatedValueForinputSeverity) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Severity: ' + this.state.severityList[this.state.severityList.findIndex((el) => el.id == updatedValueForinputSeverity)].severity
    }

    let updatedValueForAvid = this.state.selectedAvidLabel != this.state.alert.avidObj.label;
    if (updatedValueForAvid) {
      actionTakenObj.actionTaken = actionTakenObj.actionTaken + ',UPDATE: Update Team: ' + (this.state.selectedAvidLabel ? this.state.selectedAvidLabel : 'No Team')
    }
    let updatedValueForDueDate = this.state.alert.dueDate !== format(this.state.inputDueDate, 'MM/dd/yyyy').split('T')[0];
    if (updatedValueForDueDate) {
      actionTakenObj.actionTaken += `,UPDATE: Update Due Date: ${format(this.state.inputDueDate, 'MM/dd/yyyy').split('T')[0]}`;
    }

    return actionTakenObj;
  }

  resolvedAlertType() {
    const { alertTypes, alert } = this.state;
    let alertType = undefined
    if (window.location.pathname == "/coaching_form" || alert.source === "Individual Survey") {
      alertType = alertTypes.find((type) => type.name == 'Individual Survey').id
    }
    return (alertType ? alertType : alertTypes.find((type) => type.name == 'Basic Alert').id);
  }

  createNewAlert() {
    let getId = userData.getUserId()
    getId.then((id) => {
      let data = new FormData;
      data['assignTo'] = Number(this.state.inputAssignee);
      data['dueDate'] = format(this.state.inputDueDate, 'MM/dd/yyyy');
      data['reason'] = this.state.inputReason;
      data['alertType'] = this.resolvedAlertType();
      data['description'] = this.state.inputDescription;
      data['actionTaken'] = this.state.inputActionTaken;
      data['status'] = this.state.inputStatus;
      data['severity'] = this.state.inputSeverity;
      data['rootCause'] = this.state.inputRootCause;
      data['endState'] = this.state.inputEndState;
      data['userId'] = id;
      data['current_project'] = userData.getCurrentProject();
      data['externalReferenceID'] = (this.state.alert.externalReferenceID ? this.state.alert
        .externalReferenceID : this.state.alert.id);
      data['avid'] = this.state.selectedAvid;
      data['avidLabel'] = this.state.selectedAvidLabel;
      if (this.isValidForm()) {
        // Show progress: Creating alert - start immediately
        this.setState({ isCreatingAlert: true, creationProgress: 'creating' });

        const method = 'POST';
        HttpRequest.fetch('scripts/my_alerts/add_new_alert', { data, method })
          .then((res: any) => {
            // Alert created successfully - mark step 1 complete
            this.setState({ creationProgress: 'creating_complete' });

            // Check if Jack Henry sync occurred
            const jhSync = res.jack_henry_sync;
            if (jhSync && (jhSync.status === 'synced' || jhSync.status === 'failed')) {
              // Show syncing step
              setTimeout(() => {
                this.setState({ creationProgress: 'syncing' });

                // Show result after brief delay
                setTimeout(() => {
                  if (jhSync.status === 'synced') {
                    this.setState({ creationProgress: 'syncing_complete' });
                  } else {
                    this.setState({ creationProgress: 'syncing_failed' });
                    Materialize.toast('Alert created but Jack Henry sync failed', 3500, 'toast-warning');
                  }

                  // Complete after showing result
                  setTimeout(() => {
                    this.completeAlertCreation(res, id);
                  }, 800);
                }, 500);
              }, 300);
            } else {
              // No Jack Henry sync (not applicable) - complete immediately
              setTimeout(() => {
                this.completeAlertCreation(res, id);
              }, 500);
            }
          }).catch((err) => {
            console.log(err);
            this.setState({ isCreatingAlert: false, creationProgress: undefined });
            Materialize.toast('Error creating alert', 2500, 'toast-error');
          });
      } else {
        this.setState({ isValid: false, pristine: false });
      }
    });
  }

  completeAlertCreation(res: any, userId: number) {
    const { newUser } = this.state;
    const $alertFormAside = $('#AlertFormAside');
    $alertFormAside.modal('close');
    Materialize.toast('Added alert', 2500, 'toast-alert');
    this.resetFormInputs();
    const user = this.state.users.find((user) => user.id == this.state.inputAssignee);
    const assigner = this.state.users.find((user) => user.id == userId);
    const reason = this.state.reasons.find((reason) => reason.id == this.state.inputReason);

    const dueDateString = new Date(this.state.inputDueDate).toLocaleString().split(',')[0]

    notify(newUser, this.state.adminList, '', user, assigner, user.email, this.state.alert.createdOn, res.id, 'Basic Alert', reason.reason, this.state.projectName, '', userId, window.location.origin, this.state.customerMemberName, dueDateString, this.state.inputDescription);

    this.setState({ newUser: false, isCreatingAlert: false, creationProgress: undefined });
    // Fire update Data Grid event
    const updateRecords = new CustomEvent('updateRecords', { detail: 'hello' });
    window.dispatchEvent(updateRecords);
  }

  warnNewUser(warningType?: string) {
    const { newUserEmail } = this.state;
    let confirmationModalText: string;
    if (warningType == 'confirmation')
      confirmationModalText = `${(newUserEmail ? newUserEmail : 'Last created user ')} will be added as an ALERTS ONLY user on the Avannis application. They will only be able to view alerts assigned to them. Your administrator will be notified of the creation of a new user and have the option to grant additional permissions.`;
    else
      confirmationModalText = `If you cancel this Action Alert the New Alerts Only User you assigned to this alert, ${newUserEmail}, will not be created.`
    this.setState({ confirmationModalText: confirmationModalText, isConfirmationModalOpen: true, confirmationProcess: (warningType == 'confirmation') });
  }

  startProcessCreate() {
    if (this.isValidForm()) {
      if (this.state.newUser) {
        this.warnNewUser('confirmation');
      } else {
        // Check for the user to be valid
        const { inputAssignee } = this.state;
        verifyActiveUser(inputAssignee).then((res) => {
          if (res > 0)
            if (this.state.selectedAvid && this.state.selectedAvid.length > 0 && this.state.selectedAvid !== 'No Team') {
              verifyAvidAccess(inputAssignee, this.state.selectedAvid).then((hasAccess) => {
                if (hasAccess) this.createNewAlert();
                else {
                  this.setState({ teamConfirmationText: 'Please confirm this is the correct team for this alert.' }, () => {
                    this.setState({ isConfirmTeamModalOpen: true });
                  });
                }
              })
            } else {
              this.setState({ teamConfirmationText: 'You have not selected a team for this alert. Please confirm or select "Cancel" to go back and select a team.' }, () => {
                this.setState({ isConfirmTeamModalOpen: true });
              });
            }
          else {
            this.setState({ isInactiveUser: true });
          }
        });
      }
    } else
      this.setState({ isValid: false, pristine: false });
  }

  startProcessCancelCreate() {
    if (this.state.newUser) {
      this.warnNewUser();
    } else {
      this.setEditMode(false);
      this.setState({ isValid: true });
      if (this.state.isNewAlert)
        this.props.toggleModal(!this.props.isOpen);
    }
  }
  startProcessUpdate() {
    if (this.isValidForm()) {
      if (this.state.newUser) {
        this.warnNewUser('confirmation');
      } else {
        // Check for the user to be valid
        const { inputAssignee } = this.state;
        verifyActiveUser(inputAssignee).then((res) => {
          if (res > 0)
            if (this.state.selectedAvid && this.state.selectedAvid.length > 0 && this.state.selectedAvid !== 'No Team') {
              verifyAvidAccess(inputAssignee, this.state.selectedAvid).then((hasAccess) => {
                if (hasAccess) this.updateAlert();
                else {
                  this.setState({ teamConfirmationText: 'Please confirm this is the correct team for this alert.' }, () => {
                    this.setState({ isConfirmTeamModalOpen: true });
                  });
                }
              })
            } else {
              this.setState({ teamConfirmationText: 'You have not selected a team for this alert. Please confirm or select "Cancel" to go back and select a team.' }, () => {
                this.setState({ isConfirmTeamModalOpen: true });
              });
            }
          else {
            this.setState({ isInactiveUser: true });
          }
        });
      }
    } else {
      this.setState({ isValid: false, pristine: false });
    }
  }

  startProcessCancel() {
    if (this.state.newUser) {
      this.warnNewUser();
    } else {
      this.setEditMode(false);
      this.setState({ isValid: true });
    }
  }

  updateAlert() {
    const { inputAssignee, inputDueDate, users, statusTypes, rootCauses, endStates, reasons, alert, inputReason, inputDescription, inputStatus, inputSeverity, inputRootCause, inputEndState, severityList } = this.state;

    const inputAssigneeIdx = users.findIndex((IUser) => IUser.id == inputAssignee);
    const inputRootCauseIdx = rootCauses.findIndex((IRootCause) => IRootCause.id == inputRootCause);
    const inputEndStateIdx = endStates.findIndex((IEndState) => IEndState.id == inputEndState);
    const inputReasonIdx = reasons.findIndex((IReason) => IReason.id == inputReason);
    const inputSeverityIdx = severityList.findIndex((ISeverity) => ISeverity.id == this.state.inputSeverity);

    const prevReasonIdx = reasons.findIndex((IReason) => IReason.id == alert.reason);
    const prevAssigneeIdx = users.findIndex((IUser) => IUser.id == alert.assignedToID);
    const prevStatusIdx = statusTypes.findIndex((IStatus) => IStatus.id == alert.statusID);
    const prevRootCauseIdx = rootCauses.findIndex((IRootCause) => IRootCause.id == alert.rootCauseID);
    const prevEndStateIdx = endStates.findIndex((IEndStates) => IEndStates.id == alert.endStateID);
    const prevSeverityIdx = severityList.findIndex((ISeverity) => ISeverity.id == alert.severityID);

    let getId = userData.getUserId()

    getId.then((id) => {
      const currentUsernameIdx = users.findIndex((item) => item.id == id);
      let data = new FormData;
      const actionTakenObj = this.getActionTaken();
      data['assignTo'] = (inputAssignee ? inputAssignee : id);
      data['dueDate'] = this.state.inputDueDate ? format(this.state.inputDueDate, 'yyyy-MM-dd') : undefined;
      data['reason'] = (inputReason ? inputReason : undefined);
      data['description'] = (inputDescription ? inputDescription : '');
      data['alertType'] = this.resolvedAlertType();
      data['actionTaken'] = actionTakenObj.actionTaken
      data['status'] = (inputStatus ? inputStatus : undefined);
      data['statusLabel'] = (inputStatus ? statusTypes.find((item) => item.id == data['status']).status : undefined);
      data['severity'] = (inputSeverity ? inputSeverity : undefined);
      data['rootCause'] = (inputRootCause ? inputRootCause : undefined);
      data['endState'] = (inputEndState ? inputEndState : undefined);
      data['userId'] = id;
      data['alertID'] = alert.id;
      data['username'] = (currentUsernameIdx > -1 ? users[currentUsernameIdx].username : '');
      data['reasonText'] = (inputReasonIdx > -1 ? reasons[inputReasonIdx].reason : '');
      data['assigneeText'] = (inputAssigneeIdx > -1 ? users[inputAssigneeIdx].username : '');
      data['rootCauseText'] = (inputRootCauseIdx > -1 ? rootCauses[inputRootCauseIdx].rootCause : '');
      data['endStateText'] = (inputEndStateIdx > -1 ? endStates[inputEndStateIdx].endState : '');
      data['current_project'] = userData.getCurrentProject();
      data['severityText'] = (inputSeverityIdx > -1 ? severityList[inputSeverityIdx].severity : '');
      data['avid'] = this.state.selectedAvid;
      data['avidLabel'] = this.state.selectedAvidLabel;

      // Prev Alert Values

      data['prevSeverity'] = (prevSeverityIdx > -1 ? severityList[prevSeverityIdx].severity : '');
      data['prevDueDate'] = alert.dueDate;
      data['prevReason'] = (prevReasonIdx > -1 ? reasons[prevReasonIdx].reason : '');
      data['prevAssignee'] = (prevAssigneeIdx > -1 ? users[prevAssigneeIdx].username : '');
      data['prevDescription'] = alert.description;
      data['prevStatus'] = (prevStatusIdx > -1 ? statusTypes[prevStatusIdx].status : '');
      data['prevRootCause'] = (prevRootCauseIdx > -1 ? rootCauses[prevRootCauseIdx].rootCause : '');
      data['prevEndState'] = (prevEndStateIdx > -1 ? endStates[prevEndStateIdx].endState : '');
      data['prevSelectedAvid'] = (this.state.alert.avidObj.avid ? this.state.alert.avidObj.avid : 'Non specified');
      data['prevSelectedAvidLabel'] = (this.state.alert.avidObj.label ? this.state.alert.avidObj.label : 'Non specified');
      if (this.isValidForm()) {
        // Show progress: Updating alert - start immediately
        this.setState({ isUpdatingAlert: true, updateProgress: 'updating' });

        const method = 'POST';
        HttpRequest.fetch('scripts/alert_form/update_alert', { data, method })
          .then((res: any) => {
            // Alert updated successfully - mark step 1 complete
            this.setState({ updateProgress: 'updating_complete' });

            // Check if Jack Henry sync occurred
            const jhSync = res.jack_henry_sync;
            if (jhSync && (jhSync.status === 'synced' || jhSync.status === 'failed')) {
              // Show syncing step
              setTimeout(() => {
                this.setState({ updateProgress: 'syncing' });

                // Show result after brief delay
                setTimeout(() => {
                  if (jhSync.status === 'synced') {
                    this.setState({ updateProgress: 'syncing_complete' });
                  } else {
                    this.setState({ updateProgress: 'syncing_failed' });
                    Materialize.toast('Alert updated but Jack Henry sync failed', 3500, 'toast-warning');
                  }

                  // Close modal and cleanup after showing final status
                  setTimeout(() => {
                    const { newUser } = this.state;
                    const assigner = this.state.users.find((user) => user.id == id);
                    const reason = this.state.reasons.find((reason) => reason.id == this.state.inputReason);
                    const $alertFormAside = $('#AlertFormAside');
                    $alertFormAside.modal('close');
                    Materialize.toast('Alert updated', 2500, 'toast-alert');
                    const newAssignee = this.state.users.find((user) => user.id == this.state.inputAssignee);
                    const dueDateString = new Date(inputDueDate).toLocaleString().split(',')[0]
                    if (actionTakenObj.shouldNotify) {
                      notify(newUser, this.state.adminList, '', newAssignee, assigner, newAssignee.email, this.state.alert.createdOn, res.id, this.state.alert.source, reason.reason, this.state.projectName, '', id, window.location.origin, this.state.customerMemberName, dueDateString, inputDescription);
                    }
                    // Fire update Data Grid event
                    const updateRecords = new CustomEvent('updateRecords', { detail: 'updateAlert' });
                    window.dispatchEvent(updateRecords);
                    //this refreshes the my alerts table
                    const myAlertsUpdate = new CustomEvent('myAlertsUpdate', { detail: 'myAlertsUpdate' });
                    window.dispatchEvent(myAlertsUpdate);

                    this.setState({ newUser: false, isUpdatingAlert: false, updateProgress: undefined });
                  }, 1000);
                }, 500);
              }, 500);
            } else {
              // No Jack Henry sync - close immediately
              const { newUser } = this.state;
              const assigner = this.state.users.find((user) => user.id == id);
              const reason = this.state.reasons.find((reason) => reason.id == this.state.inputReason);
              const $alertFormAside = $('#AlertFormAside');
              $alertFormAside.modal('close');
              Materialize.toast('Alert updated', 2500, 'toast-alert');
              const newAssignee = this.state.users.find((user) => user.id == this.state.inputAssignee);
              const dueDateString = new Date(inputDueDate).toLocaleString().split(',')[0]
              if (actionTakenObj.shouldNotify) {
                notify(newUser, this.state.adminList, '', newAssignee, assigner, newAssignee.email, this.state.alert.createdOn, res.id, this.state.alert.source, reason.reason, this.state.projectName, '', id, window.location.origin, this.state.customerMemberName, dueDateString, inputDescription);
              }
              // Fire update Data Grid event
              const updateRecords = new CustomEvent('updateRecords', { detail: 'updateAlert' });
              window.dispatchEvent(updateRecords);
              //this refreshes the my alerts table
              const myAlertsUpdate = new CustomEvent('myAlertsUpdate', { detail: 'myAlertsUpdate' });
              window.dispatchEvent(myAlertsUpdate);

              this.setState({ newUser: false, isUpdatingAlert: false, updateProgress: undefined });
            }
          }).catch((err) => {
            console.log(err);
            this.setState({ isUpdatingAlert: false, updateProgress: undefined });
            Materialize.toast('Error updating alert', 2500, 'toast-error');
          });
      } else {
        this.setState({ isValid: false, pristine: false });
      }
    });
  }

  isValidForm() {
    let stateProps = Object.keys(this.state);
    for (let index = 0; index < stateProps.length; index++) {
      const prop = stateProps[index];
      if (prop.indexOf('input') >= 0) {
        if ((this.state[prop] == -1 || this.state[prop].length == 0) && this.state.requiredInputs.indexOf(prop) >= 0) return false;
      }
    }
    return true;
  }

  checkForUserValidation() {
    // Check for the user to be valid
    const { inputAssignee, users } = this.state;
    const inputAssigneeIdx = users.findIndex((IUser) => IUser.id == inputAssignee);
    verifyActiveUser(inputAssigneeIdx).then(() => {

    });
  }

  deleteAlert() {
    const getId = userData.getUserId()
    getId.then((id) => {
      const data = { id: this.state.alert.id, userId: id };
      const method = 'POST';
      HttpRequest.fetch('scripts/action_alerts/action_alert/deleteActionItem', { data, method })
        .then(() => {
          const $alertFormAside = $('#AlertFormAside');
          $alertFormAside.modal('close');
          Materialize.toast('Alert deleted', 2500, 'toast-alert');
          // Fire update Data Grid event
          const updateRecords = new CustomEvent('updateRecords', { detail: 'hello' });
          window.dispatchEvent(updateRecords);
        }).catch((err) => {
          console.log(err);
        });
    })
  }

  getCustomerInfo() {
    const { alert } = this.state;
    if (alert.externalReferenceID > 0) {
      const data = { client: userData.getCurrentProject(), coachingFormID: alert.externalReferenceID };
      const method = 'POST';
      HttpRequest.fetch('scripts/alert_form/getCustomerInfo', { data, method })
        .then((res: any) => {
          let customerInfo: ICustomerInformation = { name: '', email: '', phoneNumber: '' };
          for (let [key, value] of Object.entries(res)) {
            if (value['tag']) {
              if (value['tag'].includes('phone')) {
                customerInfo.phoneNumber = value['value'];
              }
              if (value['tag'].includes('email')) {
                customerInfo.email = value['value'];
              }
              if (!value['tag'].includes('phone') && !value['tag'].includes('email')) {
                customerInfo.name = value['value'];
              }
            }
          }
          this.setState({ customerInfo: customerInfo });
        });
    } else this.setState({ customerInfo: { name: '', email: '', phoneNumber: '' } });
  }

  getNotes() {
    const { isNewAlert, alert, users } = this.state;
    if (!isNewAlert && alert) {
      const data = { id: this.state.alert.id };
      const method = 'POST';
      userData.getUserId().then((id) => {
        HttpRequest.fetch('scripts/alert_form/get_notes', { data, method })
          .then((res: Note[]) => {
            let notes = res.map((note) => {
              const userIdx = users.findIndex((item) => item.id == note.userId);
              note.userName = (userIdx > -1 ? users[userIdx].username : 'Non specified');
              note.createTime = format(new Date(note.createTime), 'P');
              note.editable = note.userId == id;
              return note;
            });
            this.setState({ notes: notes });
          });
      })
    }
  }

  getHistory() {
    const { statusTypes } = this.state;
    if (!this.state.isNewAlert && this.state.alert) {
      const data = { id: this.state.alert.id };
      const method = 'POST';
      HttpRequest.fetch('scripts/alert_form/get_history', { data, method })
        .then((res: historyRecord[]) => {
          let records = res.map((record) => {
            record.statusText = statusTypes[statusTypes.findIndex((item) => item.id == record.status)].status;
            record.date = format(new Date(record.date), 'P');
            return record;
          });
          this.setState({ history: records });
        });
    }
  }

  deleteNote(id: number) {
    if (id) {
      const data = { id: id };
      const method = 'POST';
      HttpRequest.fetch('scripts/alert_form/delete_note', { data, method })
        .then((res: Response) => {
          if (res.success) {
            let notes = this.state.notes.filter((note) => note.id != id);
            this.setState({ notes: notes });
            if (detectIE() > 12 || !detectIE()) {
              const noteSavedEvent = new Event('noteSavedEvent');
              window.dispatchEvent(noteSavedEvent)
              this.setState({ targetNote: undefined })
            }
          }
        }).catch((err) => {
          console.log(err);
        });
    }
  }

  addNote() {
    $('#addNoteModal').modal('open');
  }

  updateNotesModalState(isOpen: boolean) {
    this.setState({ isNotesModalOpen: isOpen });
  }

  createLinkedAlert() {
    this.setState({ isChildAlert: true });
    this.setState({ isNewAlert: true });
    this.setState({ inputStatus: 0 });
    // Clear inputs
    this.cleanInputs();
    // Set view mode
    this.setState({ isEditMode: true });
  }

  loadParentAlert(id: number) {
    let alert = this.state.alert;
    alert.id = id;
    this.setState({ alert: alert }, () => { this.loadAlert(id) });
  }

  renderStatusBadge() {
    if (this.state.alert && this.state.alert.status) {
      return (
        <span className="badge badge-pill badge-light" style={{ color: this.state.alert.statusColor }}>
          <i className={"fas fa-fw fa-lg fa-" + this.getStatusIcon(this.state.alert.status)} /> {this.state.alert.status}
        </span>
      );
    } else {
      return (
        <span className="badge badge-pill badge-light" style={{ color: 'pink' }}>
          <i className="fas fa-fw fa-lg fa-bell" /> New
        </span>
      );
    }
  }
  renderSeverityBadge() {
    if (this.state.alert && this.state.alert.severity) {
      return (
        <span className="badge badge-pill badge-light" style={{ color: this.state.alert.severityColor }}>
          <i className="fas fa-fw fa-lg fa-exclamation-triangle" /> {this.state.alert.severity}
        </span>
      );
    } else {
      return (
        <span className="badge badge-pill badge-light" style={{ color: '#6c757d' }}>
          <i className="fas fa-fw fa-lg fa-exclamation-triangle" /> Low
        </span>
      );
    }
  }

  renderProgressBar(created, due) {
    const currentStatus = this.state.statusTypes.find(s => s.id === Number(this.state.inputStatus)).status;
    const createdDate = new Date(created);
    const dueDate = new Date(due);
    const today = new Date();
    const totalDiff = differenceInDays(dueDate, createdDate);
    const relativeDiff = differenceInDays(dueDate, today);

    let progressBarValue = 100 - ((100 * relativeDiff) / totalDiff);
    if (progressBarValue <= 100 && due) {
      return (
        <div className={this.state.alert.dueDate ? "progress" : "d-none"}>
          <div className="progress-bar" role="progressbar" style={{ width: String(progressBarValue) + '%' }}><i className="fas fa-circle" /></div>
        </div>
      );
    } else {
      if (due) {
        return (
          <span className="small text-danger">Overdue!</span>
        );
      }
    }
  }

  dismissNewUserWarning() {
    this.setState({ newUserWarning: false });
  }

  updateDueDate(date: Date) {
    this.setState({ inputDueDate: date })
  }

  renderForm() {
    const { isValid, users, inputAssignee, requiredInputs, enabledInputs, endStates, inputDescription, inputDueDate, inputEndState, inputReason, inputRootCause, inputSeverity, inputStatus, isInactiveUser, newUserWarning, pristine, reasons, rootCauses, severityList, statusTypes, defaultHierarchyValue, hierarchyValues, noTeamCheckbox } = this.state;
    if (this.state.isEditMode) {
      return (
        <FormEdit
          handleInputChange={(e) => this.handleInputChange(e)}
          dismissNewUserWarning={() => this.dismissNewUserWarning()}
          refreshUsers={() => this.refreshUsers()}
          updateUserInput={(selectedUserID, newUser, newUserEmail) => this.updateUserInput(selectedUserID, newUser, newUserEmail)}
          updateDueDate={(date) => this.updateDueDate(date)}
          updateActionAlertAvid={(avid) => this.updateActionAlertAvid(avid)}
          updateNoTeamCheckbox={() => this.updateNoTeamCheckbox()}
          defaultHierarchyValue={defaultHierarchyValue}
          enabledInputs={enabledInputs}
          endStates={endStates}
          inputAssignee={inputAssignee}
          inputDescription={inputDescription}
          inputDueDate={inputDueDate}
          inputEndState={inputEndState}
          inputReason={inputReason}
          inputRootCause={inputRootCause}
          inputSeverity={inputSeverity}
          inputStatus={inputStatus}
          isInactiveUser={isInactiveUser}
          isValid={isValid}
          newUserWarning={newUserWarning}
          noTeamCheckbox={noTeamCheckbox}
          pristine={pristine}
          reasons={reasons}
          requiredInputs={requiredInputs}
          rootCauses={rootCauses}
          severityList={severityList}
          statusTypes={statusTypes}
          users={users}
          hierarchyValues={hierarchyValues}
        />
      );
    } else {
      return (
        <FormView
          assignedBy={this.state.alert.assignedBy}
          assignedTo={this.state.alert.assignedTo}
          avid={this.state.alert.avidObj.label}
          description={this.state.alert.description}
          endState={this.state.alert.endState}
          reasonLabel={this.state.alert.reasonLabel}
          rootCause={this.state.alert.rootCause}
          enabledInputs={enabledInputs}
        />
      );
    }
  }

  confirmTeam(inputHierarchyValues: string[]): void {
    const userAvids = [];
    if (this.state['inputHierarchyValues'] !== inputHierarchyValues) {
      const update: any = {}
      update['inputHierarchyValues'] = inputHierarchyValues
      update['inputSelectedAvid'] = [...inputHierarchyValues].pop()
      this.setState(update, () => {
        if (userAvids.includes(this.state.inputSelectedAvid)) {
          this.updateActionAlertAvid(this.state.inputHierarchyValues);
        } else {
          alert('open modal')
        }
      });
    }
  }

  updateNoTeamCheckbox(): void {
    this.setState({ noTeamCheckbox: !this.state.noTeamCheckbox }, () => {
      const { noTeamCheckbox } = this.state;
      if (noTeamCheckbox) {
        this.setState({ selectedAvid: 'No Team', selectedAvidLabel: 'No Team' });
      }
    });
  }

  updateActionAlertAvid(hierarchyValues: string[]): void {
    //Update State
    if (this.state['hierarchyValues'] !== hierarchyValues) {
      const update: any = {}
      update['hierarchyValues'] = hierarchyValues
      this.setState(update)
    }
    let selectedAvid = [...hierarchyValues].pop();
    this.setState({ selectedAvid: selectedAvid });
    getAvidLabel(selectedAvid).then((avidLabel) => {
      this.setState({ selectedAvidLabel: avidLabel });
    })
  }

  renderRecordControls(isEditMode) {
    const { isCreatingAlert } = this.state;
    if (isEditMode) {
      if (this.state.isNewAlert || this.state.isChildAlert) {
        return (
          <div className="d-flex justify-content-around" style={{ minWidth: '50%' }}>
            <button type="button" className="btn btn-secondary" onClick={() => this.startProcessCancelCreate()} disabled={isCreatingAlert}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={() => this.startProcessCreate()} disabled={isCreatingAlert}>
              {isCreatingAlert ? (
                <>
                  <Spinner style={{ width: '1rem', height: '1rem', marginRight: '8px' }} />
                  Creating...
                </>
              ) : 'Create'}
            </button>
          </div>
        );
      }
      return (
        <div className="d-flex justify-content-around" style={{ minWidth: '50%' }}>
          <button type="button" className="btn btn-secondary" onClick={() => this.startProcessCancel()}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={() => this.startProcessUpdate()}>{this.state.isNewAlert ? 'Create' : 'Update'}</button>
        </div>
      );
    } else {
      return (
        <button type="button" className="btn btn-light right-align" onClick={() => this.setEditMode(true)}>Modify Alert</button>
      );
    }
  }

  renderCustomerInfo() {
    if ((!this.state.isEditMode && this.props.customer) || (!this.state.isEditMode && this.state.customerInfo)) {
      const customer = (this.state.customerInfo ? this.state.customerInfo : this.props.customer);
      if (customer.name.length > 0) {
        return (
          <div className="customer-info">
            <h6>{customer.name}</h6>
            <p><i className="far fa-envelope" /> <span>{customer.email}</span></p>
            <p><i className="fas fa-phone" /> <span>{customer.phoneNumber}</span></p>
          </div>
        );
      }
    }
  }

  renderNotesSection() {
    let { notesModalOpen } = this.state;
    if (!this.state.isEditMode && !this.state.isNewAlert && this.state.alert.id) {
      return (
        <section className="coaching-notes">
          <header>
            Coaching Notes
            <button type="button" className="btn btn-link" onClick={() => this.setState({ notesModalOpen: true })}><i className="fas fa-plus" /></button>
            <Modal
              isOpen={notesModalOpen}
              wrapClassName="blacklight"
              modalClassName="blacklight-modal"
            >
              <ModalHeader>Add a Coaching Note</ModalHeader>
              <ModalBody>
                <textarea id="inputAddNote" name="inputAddNote" rows={5} cols={33} className="materialize-textarea" required={true} value={this.state.inputAddNote} onChange={this.handleInputChange} />
              </ModalBody>
              <ModalFooter>
                <Button outline color="secondary" onClick={() => this.setState({ notesModalOpen: false })}>CANCEL</Button>{' '}
                <Button outline color="primary" onClick={() => this.saveNote()}>SAVE</Button>
              </ModalFooter>
            </Modal>
          </header>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Comment Date</th>
                <th scope="col">User</th>
                <th scope="col">Message</th>
                <th scope="col">Delete?</th>
              </tr>
            </thead>
            <tbody>
              {this.state.notes.map(function (note, idx) {
                return (
                  <tr key={'note-' + idx}>
                    <td scope="row">{note.createTime}</td>
                    <td>{note.userName}</td>
                    <td>{note.message}</td>
                    <td><button type="button" className={(note.editable ? "btn btn-link" : "btn btn-link hide")} onClick={() => {
                      this.setState({ targetNote: note.id, openDeleteModalConfirmationPopUp: true })
                    }}>Delete</button></td>
                  </tr>
                )
              }, this)}
            </tbody>
          </table>
        </section>
      );
    }
  }

  saveNote() {
    let alertId = this.state.alert.id;
    let message = this.state.inputAddNote;
    userData.getUserId().then((userID) => {
      const data = { alertId: alertId, userId: userID, message: message }
      const method = 'POST';
      HttpRequest.fetch('scripts/alert_form/add_note', { data, method })
        .then((res: any) => {
          if (res.success) {
            this.setState({ notesModalOpen: false, inputAddNote: '' }, () => {
              this.getNotes();
              if (detectIE() > 12 || !detectIE()) {
                const noteSavedEvent = new Event('noteSavedEvent');
                window.dispatchEvent(noteSavedEvent)
              }
            });
          }
        })
    });
  }

  renderHistorySection() {
    if (!this.state.isEditMode) {
      return (
        <section className="coaching-notes">
          <header>
            History
          </header>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">User</th>
                <th scope="col">Action Taken</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.history.map(function (record, idx) {
                return (
                  <tr key={'record-' + idx}>
                    <td scope="row">{record.date}</td>
                    <td>{record.username}</td>
                    <td>{this.renderActionTaken(record.actionTaken)}</td>
                    <td>{record.statusText}</td>
                  </tr>
                )
              }, this)}
            </tbody>
          </table>
        </section>
      );
    }
  }

  renderActionTaken(actionTaken: string) {
    let data = actionTaken.split('UPDATE: ');
    let properties = [];
    if (data.length > 0) {
      for (let index = 1; index < data.length; index++) {
        const property = data[index];
        properties.push(property.split(':'));
      }
    }
    return (
      <>
        {data[0].length > 1 &&
          <p>{data[0]}</p>
        }
        {properties.map(function (property, idx) {
          return (
            <p key={'action-taken-' + idx}>
              <span className="previous">{property[0]}:&nbsp;</span>&nbsp;<span className="next">{property[1]}</span>
            </p>
          );
        })}
      </>
    );
  }
  returnStrActionTaken(actionTaken: string) {
    let data = actionTaken.split('UPDATE: ');
    let properties = [];
    let actionTakenStr = '';
    if (data.length > 0) {
      for (let index = 1; index < data.length; index++) {
        const property = data[index];
        properties.push(property.split(':'));
      }
    }
    properties.forEach((property, idx) => {
      actionTakenStr += (idx > 0 ? ' ' + property[0] + ': ' + property[1] : property[0] + ': ' + property[1]);
    });
    return actionTakenStr
  }

  renderLinkToExternal() {
    let alert: Alert = Object.assign(this.state.alert);
    if (!this.state.isEditMode) {
      if (alert.externalReferenceID && alert.source == 'Basic Alert') {
        return (
          <div className="d-flex align-items-center justify-content-between">
            <button className="btn btn-link external" onClick={() => {
              this.setState({ isLoadingExternalRef: true })
              this.loadParentAlert(this.state.alert.externalReferenceID)
              setTimeout(() => {
                this.setState({ isLoadingExternalRef: false })
              }, 1500);
            }}>Link to survey #{this.state.alert.externalReferenceID} <Spinner color="primary" style={{ width: "1rem", height: "1rem" }} className={(this.state.isLoadingExternalRef ? '' : 'invisible')} /></button>
          </div>
        );
      }
      if (alert.externalReferenceID && alert.source == 'Individual Survey') {
        return (
          <div className="d-flex align-items-center justify-content-between">
            <button className="btn btn-link external" onClick={() => {
              this.setState({ isLoadingExternalRef: true })
              this.openCoachingForm(this.state.alert.externalReferenceID)
              setTimeout(() => {
                this.setState({ isLoadingExternalRef: false })
              }, 1500);
            }}>Link to survey #{this.state.alert.externalReferenceID} <Spinner color="primary" style={{ width: "1rem", height: "1rem" }} className={(this.state.isLoadingExternalRef ? '' : 'invisible')} /></button>
          </div>
        );
      }

    }
  }

  renderTitle() {
    if (this.state.isNewAlert) {
      let externalDataReference = (this.state.alert.externalReferenceID > 0 ? this.state.alert.externalReferenceID : this.state.alert.id);
      return (
        <h4 className='white-text'>Create New Alert {this.state.isChildAlert ? 'Associated to ' + externalDataReference : ''}</h4>
      );
    } else {
      return (
        <h4 className='white-text'>Action Alert {this.state.alert.externalReferenceID ? 'on ' + (this.state.alert.source === 'Individual Surveys' ? 'Individual Survey' : this.state.alert.source) : ''} {this.state.alert.externalReferenceID ? '#' + this.state.alert.externalReferenceID : ''}</h4>
      );
    }
  }

  renderDotsMenu() {
    if (!this.state.isNewAlert) {
      const isBasicAlert = (this.state.alert.source == 'Basic Alert');
      return (
        <Popover btnText="" icon="ellipsis-v" useIcon>
          <section style={{ fontSize: '1rem', minWidth: 150 }}>
            {!isBasicAlert &&
              <>
                <a className="dropdown-item" onClick={() => this.createLinkedAlert()}>Create Associated Alert</a>
                <div className="dropdown-divider" />
              </>
            }
            {this.renderPrintButton()}
            <div className="dropdown-divider" />
            <a className="dropdown-item" onClick={() => {
              this.setState({ isConfirmDeleteModalOpen: true })
            }}>Delete</a>
          </section>
        </Popover>
      );
    }
  }
  renderPrintButton() {
    const { PDFready } = this.state;
    return (
      <>
        {!PDFready &&
          <a className="dropdown-item" onClick={() => prepareForExport([this.state.alert.id], this.state.users, this.state.statusTypes).then((exportedAlerts: IActionAlertForm[]) => {
            this.setState({ exportedAlerts: exportedAlerts, PDFready: true });
          })}>Print</a>
        }
        {PDFready &&
          <>
            <a className="dropdown-item disabled">PDF ready</a>
            <BlobProvider document={printExport(this.state.exportedAlerts, this.state.enabledInputs)}>
              {({ url, loading }) => {
                if (!loading) {
                  return <a className="dropdown-item" href={url} target="_blank" rel="noopener noreferrer">Download now!</a>
                } else return 'Loading'
              }}
            </BlobProvider>
          </>
        }
      </>
    );
  }


  getAdminList() {
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('/scripts/alert_form/get_admin_list', { data, method })
      .then((res: User[]) => {
        if (Array.isArray(res)) {
          this.setState({ adminList: res });
        }
      });
  }

  confirmUserCreation() {
    const { newUserEmail } = this.state;
    addUser(newUserEmail).then((res) => {
      if (res && res.id) {
        this.promiseSetUsers(res.id).then((areUsersSet) => {
          if (areUsersSet) {
            if (this.state.isNewAlert) {
              this.createNewAlert()
              this.setState({ isConfirmationModalOpen: false, newUserEmail: '', newUserWarning: false });
            } else {
              this.setState({ isConfirmationModalOpen: false, newUserEmail: '', newUserWarning: false });
              this.updateAlert();
            }
          }
        });
      }
    });
  }

  cancelUserCreation() {
    let { users, inputAssignee, alert } = this.state;
    const filteredUsers = users.filter((user) => user.id != inputAssignee);
    this.setState({ isConfirmationModalOpen: false, newUser: false, newUserEmail: '', newUserWarning: false, inputAssignee: alert.assignedToID, users: filteredUsers });
  }

  openCoachingForm(coachingFormId) {
    getCoachingFormInfo(coachingFormId).then((res) => {
      const isActionItem = res.isActionAlert;
      const page = `coaching_form?back=co&survey=${res.surveyAbbr}&id=${coachingFormId}&ai=${isActionItem}`
      const options = 'width=800,height=800,scrollbars=1,resizable=1'
      window.open(page, '', options)
    });
  }

  renderCreationProgress() {
    const { creationProgress } = this.state;

    // Determine step states
    const step1Active = creationProgress === 'creating';
    const step1Complete = creationProgress !== 'creating' && creationProgress !== undefined;

    const step2Active = creationProgress === 'syncing';
    const step2Complete = creationProgress === 'syncing_complete';
    const step2Failed = creationProgress === 'syncing_failed';
    const step2Visible = step2Active || step2Complete || step2Failed;

    return (
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center', maxWidth: '400px', padding: '30px' }}>
          <h5 style={{ marginBottom: '30px' }}>Creating Action Alert</h5>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

            {/* Step 1: Creating in Avannis */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              padding: '10px',
              borderRadius: '4px',
              background: step1Active ? '#f5f5f5' : 'transparent'
            }}>
              {step1Active && <Spinner style={{ width: '1.5rem', height: '1.5rem', minWidth: '24px' }} color="success" />}
              {step1Complete && <i className="fas fa-check-circle" style={{ fontSize: '24px', minWidth: '24px', color: '#4CAF50' }} />}
              <span style={{ flex: 1, textAlign: 'left', color: '#333' }}>
                Creating action alert in Avannis
              </span>
            </div>

            {/* Step 2: Syncing to Jack Henry (only show if applicable) */}
            {step2Visible && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                padding: '10px',
                borderRadius: '4px',
                background: step2Active ? '#f5f5f5' : 'transparent'
              }}>
                {step2Active && <Spinner style={{ width: '1.5rem', height: '1.5rem', minWidth: '24px' }} color="success" />}
                {step2Complete && <i className="fas fa-check-circle" style={{ fontSize: '24px', minWidth: '24px', color: '#4CAF50' }} />}
                {step2Failed && <i className="fas fa-exclamation-circle" style={{ fontSize: '24px', minWidth: '24px', color: '#ff9800' }} />}
                <span style={{ flex: 1, textAlign: 'left', color: '#333' }}>
                  Syncing to Jack Henry
                </span>
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }

  renderUpdateProgress() {
    const { updateProgress } = this.state;

    // Determine step states
    const step1Active = updateProgress === 'updating';
    const step1Complete = updateProgress !== 'updating' && updateProgress !== undefined;

    const step2Active = updateProgress === 'syncing';
    const step2Complete = updateProgress === 'syncing_complete';
    const step2Failed = updateProgress === 'syncing_failed';
    const step2Visible = step2Active || step2Complete || step2Failed;

    return (
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center', maxWidth: '400px', padding: '30px' }}>
          <h5 style={{ marginBottom: '30px' }}>Updating Action Alert</h5>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

            {/* Step 1: Updating in Avannis */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              padding: '10px',
              borderRadius: '4px',
              background: step1Active ? '#f5f5f5' : 'transparent'
            }}>
              {step1Active && <Spinner style={{ width: '1.5rem', height: '1.5rem', minWidth: '24px' }} color="success" />}
              {step1Complete && <i className="fas fa-check-circle" style={{ fontSize: '24px', minWidth: '24px', color: '#4CAF50' }} />}
              <span style={{ flex: 1, textAlign: 'left', color: '#333' }}>
                Updating action alert in Avannis
              </span>
            </div>

            {/* Step 2: Syncing to Jack Henry (only show if applicable) */}
            {step2Visible && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                padding: '10px',
                borderRadius: '4px',
                background: step2Active ? '#f5f5f5' : 'transparent'
              }}>
                {step2Active && <Spinner style={{ width: '1.5rem', height: '1.5rem', minWidth: '24px' }} color="success" />}
                {step2Complete && <i className="fas fa-check-circle" style={{ fontSize: '24px', minWidth: '24px', color: '#4CAF50' }} />}
                {step2Failed && <i className="fas fa-exclamation-circle" style={{ fontSize: '24px', minWidth: '24px', color: '#ff9800' }} />}
                <span style={{ flex: 1, textAlign: 'left', color: '#333' }}>
                  Syncing to Jack Henry
                </span>
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }


  render() {
    const { isLoading, confirmationProcess } = this.state;
    const currentStatusInput = this.state.statusTypes.find(s => s.id === Number(this.state.inputStatus))
    const currentStatus = (currentStatusInput ? currentStatusInput.status : 'New')
    return (
      <Modal
        isOpen={this.props.isOpen}
        wrapClassName="blacklight"
        modalClassName="blacklight-modal aside-modal right"
        className='right'
        toggle={() => {
          this.props.toggleModal(!this.props.isOpen);
          this.setState({ PDFready: !this.props.isOpen });
        }}
      >
        {isLoading &&
          <Spinner color="secondary" style={{ width: '3rem', height: '3rem', margin: 'auto' }} />
        }
        {!isLoading &&
          <div>
            <ModalHeader>
              <div className="row d-flex align-items-center">
                <div className="col-10">
                  {this.renderTitle()}
                  {this.renderSeverityBadge()}
                  {this.renderStatusBadge()}
                </div>
                <div className="col-2">
                  {this.renderDotsMenu()}
                </div>
              </div>
            </ModalHeader>
            <ModalHeader
              className='dates-bar'
            >
              <div className="d-flex align-items-baseline justify-content-between">
                <span className="small text-muted">Created: {this.state.alert.createdOn}</span>
                {(currentStatus === 'New' || currentStatus === 'Pending') &&
                  this.renderProgressBar(this.state.alert.createdOn, this.state.alert.dueDate)
                }
                {(currentStatus === 'New' || currentStatus === 'Pending') &&
                  <span className={this.state.alert.dueDate ? 'small text-muted' : 'd-none'}>Due: {this.state.alert.dueDate}</span>
                }
              </div>
            </ModalHeader>
            <ModalBody>
              {this.state.isCreatingAlert && this.renderCreationProgress()}
              {this.state.isUpdatingAlert && this.renderUpdateProgress()}
              <div className="blacklight container">
                <h5>Alert Details {(this.state.alert.id ? ` #${this.state.alert.id.toString()}` : '')}</h5>
                {this.renderForm()}
                <div className="alert-controls right-align">
                  {this.renderRecordControls(this.state.isEditMode)}
                </div>
                {this.renderCustomerInfo()}
                {this.renderNotesSection()}
                {this.renderHistorySection()}
                {this.renderLinkToExternal()}
              </div>
              <Modal
                isOpen={this.state.isConfirmationModalOpen}
                wrapClassName="blacklight"
                modalClassName="blacklight-modal"
                className='aside-confirmation-popup'>
                <ModalBody>
                  <p className="text-muted">{this.state.confirmationModalText}</p>
                </ModalBody>
                <ModalFooter>
                  {confirmationProcess &&
                    <>
                      <Button color="primary" onClick={() => this.confirmUserCreation()}>Confirm</Button>
                      <Button color="secondary" onClick={() => this.cancelUserCreation()}>Cancel</Button>
                    </>
                  }
                  {confirmationProcess == false &&
                    <>
                      <Button color="primary" onClick={() => {
                        this.cancelUserCreation();
                        this.setEditMode(false);
                        this.setState({ isValid: true });
                        if (this.state.isNewAlert)
                          this.props.toggleModal(!this.props.isOpen);
                      }}>Confirm</Button>
                      <Button color="secondary" onClick={() => {
                        this.setState({ isConfirmationModalOpen: false });
                      }}>Cancel</Button>
                    </>
                  }
                </ModalFooter>
              </Modal>
              <Modal
                isOpen={this.state.isConfirmTeamModalOpen}
                wrapClassName="blacklight"
                modalClassName="blacklight-modal"
                className='aside-confirmation-popup'>
                <ModalBody>
                  <p className="text-muted">{this.state.teamConfirmationText}</p>
                  {(this.state.selectedAvid && this.state.selectedAvid.length > 0) &&
                    <p className="text-muted center">{this.state.selectedAvidLabel}</p>
                  }
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={() => this.setState({ isConfirmTeamModalOpen: false })}>Cancel</Button>
                  <Button color="primary" onClick={() => this.setState({ isConfirmTeamModalOpen: false }, () => {
                    if (this.state.isNewAlert) {
                      this.createNewAlert()
                    } else {
                      this.updateAlert()
                    }
                  })}>Confirm</Button>
                </ModalFooter>
              </Modal>
              <Modal
                isOpen={this.state.isConfirmDeleteModalOpen}
                wrapClassName="blacklight"
                modalClassName="blacklight-modal"
                className='aside-confirmation-popup'>
                <ModalBody>
                  <p className="text-muted">Are you sure you want to delete this Action Alert?</p>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary"
                    onClick={() => this.setState({ isConfirmDeleteModalOpen: false })}>Cancel</Button>
                  <Button color="primary" onClick={() => this.setState({ isConfirmDeleteModalOpen: false }, () => {
                    this.deleteAlert()
                  })}>Confirm</Button>
                </ModalFooter>
              </Modal>
              <Modal
                isOpen={this.state.openDeleteModalConfirmationPopUp}
                wrapClassName="blacklight"
                modalClassName="blacklight-modal"
                className='aside-confirmation-popup'>
                <ModalBody>
                  <p className="text-muted">Are you sure you want to delete this note?</p>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary"
                    onClick={() => this.setState({ openDeleteModalConfirmationPopUp: false })}>Cancel</Button>
                  <Button color="primary" onClick={() => this.setState({ openDeleteModalConfirmationPopUp: false }, () => {
                    this.deleteNote(this.state.targetNote)
                  })}>Confirm</Button>
                </ModalFooter>
              </Modal>
            </ModalBody>
          </div>
        }
      </Modal>
    );
  }
}

